import { ReactComponent as SaveIcon } from '../../assets/saveIcon.svg'
import HistoryIcon from "@assets/icons/HistoryIcon"
import { CustomNavigate } from "@UI/CustomNavigate"
import { Row, Typography } from "antd"
import { useState } from "react"
import './styles.css'
import useCurrentLocation from '@thooks/useCurrentLocation'
import LogsDrawer from '@tcomponents/Logs/components/LogsDrawer/LogsDrawer'
import { useNewEditTemplateCollectionContext } from '../../context/NewEditTemplateCollectionContext'
import { useNewEditTemplateCollection } from '../../hooks/useNewEditTemplateCollection'
import FeatureButton from '@tcomponents/FeatureButton/FeatureButton'
import { COLLECTION_ADMINISTRATION_CODES } from '@constants/modules/collectionAdministration/collectionAdministrationCodes'

const { Paragraph } = Typography

const NewEditTemplateCollectionHeader = () => {
  const { chargeDetail, setChargeDetail, setHasUnsavedChanges } = useNewEditTemplateCollectionContext()
  const { handleSaveTemplate, loadingTemplate } = useNewEditTemplateCollection()
  const { param } = useCurrentLocation()
  const [isOpenLogsDrawer, setIsOpenLogsDrawer] = useState(false)

  return (
    <header>
      <small className="new-edit-collection-template-subtitle">
        ADMINISTRACIÓN DE COBROS / {
          param.templateId === 'new' ? 'NUEVA PLANTILLA DE COBRO' : 'EDITAR PLANTILLA DE COBRO'
        }
      </small>
      <CustomNavigate title={
        <Paragraph
          className='new-edit-collection-template-title'
          ellipsis
          editable={{
            autoSize: { minRows: 1, maxRows: 1 },
            onChange: (value) => {
              setHasUnsavedChanges(true)
              setChargeDetail(prev => ({
                ...prev,
                charge: {
                  ...prev?.charge,
                  name: value
                }
              }))
            },
            text: chargeDetail?.charge?.name,
          }}
        >
          {chargeDetail?.charge?.name}
        </Paragraph>
      }>
        <Row className="new-edit-template-collection-header" style={{ gap: 16 }} align="middle">
          <FeatureButton
            code={true}
            onClick={() => handleSaveTemplate()}
            className="btn-standard-green btn-save-collection-disabled"
            shape="round"
            style={{ width: '148px' }}
            icon={<SaveIcon />}
            loading={loadingTemplate}
            tooltip='GUARDAR'
          >
            GUARDAR
          </FeatureButton>
          {param.templateId !== 'new' ? <>
            <FeatureButton
              code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_TEMPLATE_LOGS}
              className="btn-standard-white logs-btn"
              style={{
                borderRadius: '50%',
                width: 42,
                height: 40,
              }}
              icon={<HistoryIcon />}
              onClick={() => setIsOpenLogsDrawer(true)}
              loading={loadingTemplate}
              tooltip='HISTORIAL DE CAMBIOS'
            />
            <LogsDrawer
              isOpen={isOpenLogsDrawer}
              onClose={() => setIsOpenLogsDrawer(false)}
              redirectTo={`/logs/administration-collection/template/${param.templateId}`}
              service={`/charge/detail/log`}
              logsParams={{
                charge_id: param.templateId,
              }}
            />
          </> : null}
        </Row>
      </CustomNavigate>
    </header>
  )
}

export default NewEditTemplateCollectionHeader
